import React from "react";

const MONTHS    = ["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"];
const ZW_MAX    = [5,7,10,14,18,21,23,23,19,14,9,6];

export function TemperatureChart({ monthly_max, monthly_min, label = "hier" }) {
  if (!monthly_max || !monthly_min || monthly_max.length < 12) return null;

  const W=320, H=158, P={t:10,r:8,b:26,l:28};
  const cW=W-P.l-P.r, cH=H-P.t-P.b;
  const all=[...monthly_max,...monthly_min,...ZW_MAX];
  const minV=Math.floor(Math.min(...all)/5)*5-2;
  const maxV=Math.ceil(Math.max(...all)/5)*5+2;
  const range=maxV-minV;
  const px=i=>P.l+(i/11)*cW;
  const py=v=>P.t+cH-((v-minV)/range)*cH;
  const pts=arr=>arr.map((v,i)=>`${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(" ");
  const area=(top,bot)=>{
    const f=top.map((v,i)=>`${i===0?"M":"L"}${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(" ");
    const b=[...bot].reverse().map((v,i)=>`L${px(11-i).toFixed(1)},${py(v).toFixed(1)}`).join(" ");
    return f+" "+b+" Z";
  };
  const cfTop=Math.max(P.t,Math.min(py(25),P.t+cH));
  const cfBot=Math.max(P.t,Math.min(py(15),P.t+cH));
  const sumDiff=Math.round([5,6,7].reduce((s,i)=>s+monthly_max[i],0)/3-[5,6,7].reduce((s,i)=>s+ZW_MAX[i],0)/3);
  const grid=[];
  for(let t=Math.ceil(minV/5)*5;t<=maxV;t+=5) grid.push(t);

  return (
    <div style={{marginTop:16}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
        <span style={{fontSize:12,fontWeight:600,color:"#555"}}>🌡 Temperatuur vs Zwolle</span>
        {sumDiff>0&&<span style={{fontSize:11,fontWeight:600,color:"#e64a19",background:"#fff0ea",padding:"2px 9px",borderRadius:20}}>+{sumDiff}°C zomer</span>}
      </div>
      <div style={{overflowX:"auto"}}>
        <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{display:"block",minWidth:260,overflow:"visible"}}>
          {cfBot>cfTop&&<rect x={P.l} y={cfTop} width={cW} height={cfBot-cfTop} fill="#c8e6c9" opacity="0.35" rx="2"/>}
          {grid.map(t=>(
            <g key={t}>
              <line x1={P.l} x2={P.l+cW} y1={py(t)} y2={py(t)} stroke={t===0?"#ccc":"#f0ece6"} strokeWidth={t%10===0?1:0.5}/>
              <text x={P.l-4} y={py(t)+3.5} textAnchor="end" fontSize="8" fill="#bbb">{t}°</text>
            </g>
          ))}
          <path d={area(monthly_max,monthly_min)} fill="#ff8a65" opacity="0.13"/>
          <polyline points={pts(ZW_MAX)} fill="none" stroke="#b0bec5" strokeWidth="1.5" strokeDasharray="6,3" strokeLinecap="round"/>
          <polyline points={pts(monthly_min)} fill="none" stroke="#ffab76" strokeWidth="1.5" strokeDasharray="4,2" strokeLinecap="round"/>
          <polyline points={pts(monthly_max)} fill="none" stroke="#e64a19" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          {MONTHS.map((m,i)=><text key={i} x={px(i)} y={H-6} textAnchor="middle" fontSize="8" fill="#b0b0b0">{m}</text>)}
        </svg>
      </div>
      <div style={{display:"flex",gap:14,fontSize:10,color:"#999",marginTop:4,flexWrap:"wrap",paddingLeft:2}}>
        <span style={{display:"flex",alignItems:"center",gap:4}}><svg width="18" height="6"><line x1="0" y1="3" x2="18" y2="3" stroke="#e64a19" strokeWidth="2.5"/></svg>{label} max</span>
        <span style={{display:"flex",alignItems:"center",gap:4}}><svg width="18" height="6"><line x1="0" y1="3" x2="18" y2="3" stroke="#ffab76" strokeWidth="1.5" strokeDasharray="4,2"/></svg>{label} min</span>
        <span style={{display:"flex",alignItems:"center",gap:4}}><svg width="18" height="6"><line x1="0" y1="3" x2="18" y2="3" stroke="#b0bec5" strokeWidth="1.5" strokeDasharray="6,3"/></svg>Zwolle max</span>
        <span style={{display:"flex",alignItems:"center",gap:4}}><svg width="10" height="10"><rect width="10" height="10" fill="#c8e6c9" opacity="0.7" rx="2"/></svg>comfortzone 15–25°</span>
      </div>
    </div>
  );
}
